import { TableColumnsType } from "antd";
import { MdOutlineFileDownload } from "react-icons/md";
import { BiError } from "react-icons/bi";

import { Stage } from "@types";

interface Report {
  id: number;
  stage?: Stage;
  regions: { name: string }[];
  countries: { name: string }[];
  from_date: string;
  to_date: string;
  report_on: string[];
  name: string;
}

export const getColumns = ({
  handleRowClick,
}: {
  handleRowClick: (report: any) => void;
}): TableColumnsType<Report> => [
  {
    title: "Region",
    dataIndex: "region",
    key: "region",
    width: 160,
    render: (region: string) => region,
  },
  {
    title: "Country",
    dataIndex: "country",
    key: "country",
    width: 160,
    render: (country: string) => country,
  },
  {
    title: "Report From",
    dataIndex: "from_date",
    key: "from_date",
    width: 140,
    render: (date: string) => new Date(date).toLocaleDateString(),
  },
  {
    title: "Report Till",
    dataIndex: "to_date",
    key: "to_date",
    width: 140,
    render: (date: string) => new Date(date).toLocaleDateString(),
  },
  {
    title: "Report Type",
    dataIndex: "report_on",
    key: "report_on",
    width: 200,
    render: (list: string) => list,
  },
  {
    title: "Report Title",
    dataIndex: "name",
    key: "name",
    width: 220,
  },
  {
    title: "Action",
    key: "action",
    width: 160,
    fixed: "right",
    align: "center",
    render: (report: any) => {
      return (
        <>
          {report?.stage == "Completed" ? (
            <div
              onClick={() => handleRowClick(report)}
              className="table__action__btn table__action__btn--download flex items-center gap-1  text-sm"
            >
              <div>
                <MdOutlineFileDownload className="text-xl" />
              </div>
              <div className="text-sm">download</div>
            </div>
          ) : report?.stage == "Processing" ? (
            <div className="table__action__btn table__action__btn--client flex items-center gap-1  text-sm">
              <div className="text-sm">Processing</div>
            </div>
          ) : (
            <div className="table__action__btn table__action__btn--client flex items-center gap-1  text-sm">
              <div>
                <BiError className="text-xl " style={{ color: "red" }} />
              </div>
              <div className="text-sm" style={{ color: "red" }}>
                Error
              </div>
            </div>
          )}
        </>
      );
    },
  },
];
